var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2167_2167",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2167_2167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79992 13.9826L9.76586 13.0025L7.7634 11L9.75715 9.00625L8.79121 8.0261L5.81731 11L8.79992 13.9826ZM13.1999 13.9826L16.1825 11L13.1999 8.01739L12.234 8.99754L14.2364 11L12.234 13.0025L13.1999 13.9826ZM4.86536 18.7917C4.40229 18.7917 4.01034 18.6312 3.6895 18.3104C3.36867 17.9896 3.20825 17.5976 3.20825 17.1346V4.86543C3.20825 4.40236 3.36867 4.01041 3.6895 3.68958C4.01034 3.36874 4.40229 3.20833 4.86536 3.20833H17.1345C17.5976 3.20833 17.9895 3.36874 18.3103 3.68958C18.6312 4.01041 18.7916 4.40236 18.7916 4.86543V17.1346C18.7916 17.5976 18.6312 17.9896 18.3103 18.3104C17.9895 18.6312 17.5976 18.7917 17.1345 18.7917H4.86536ZM4.86536 17.4167H17.1345C17.2051 17.4167 17.2697 17.3873 17.3284 17.3284C17.3872 17.2698 17.4166 17.2051 17.4166 17.1346V4.86543C17.4166 4.79485 17.3872 4.73022 17.3284 4.67156C17.2697 4.61274 17.2051 4.58333 17.1345 4.58333H4.86536C4.79477 4.58333 4.73015 4.61274 4.67148 4.67156C4.61266 4.73022 4.58325 4.79485 4.58325 4.86543V17.1346C4.58325 17.2051 4.61266 17.2698 4.67148 17.3284C4.73015 17.3873 4.79477 17.4167 4.86536 17.4167Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeBlocks);
export default __webpack_public_path__ + "static/media/code_blocks.1ae4e2e941d1dcf9f5377271c88de8c2.svg";
export { ForwardRef as ReactComponent };